
//import ApiService from "@/core/services/ApiService";
import { defineComponent } from "vue";
import { Field } from "vee-validate";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import { DrawerComponent } from "@/assets/ts/components/_DrawerComponent";
import ApiService from "@/core/services/ApiService";
import { apiEndpoint } from '@/mixin/apiEndpoint.js';

export default defineComponent({
  mixins: [apiEndpoint],
  name: "trainee_photo_update",
  components: {
    Field,
  },
  data() {
    return {
      api_url: '',
      trainee: {
        id: "",
        photo: "",
      },
      enrollId: "",
      url: "",
      load: false,
      loading: false,
    };
  },
  async created() {
    this.load = true;
    this.emitter.on("photo_id_updated", async (data) => {
      console.log("enroll data" + data);
      this.trainee = data;
      setTimeout(() => (this.load = false), 2000);
    });
    this.api_url = this.VUE_APP_API_URL;
  },
  methods: {
    traineePhoto(e) {
      this.trainee.photo = e.target.files[0];
      this.url = URL.createObjectURL(this.trainee.photo);
    },
    async formSubmit() {
      this.loading = true;
      let formData = new FormData();

      formData.set("photo", this.trainee.photo);
      for (var key in this.trainee) {
        formData.set(key, this.trainee[key]);
      }
      await ApiService.post("trainee/updatePhoto", formData)
        .then((response) => {
           this.loading = false;
          if (response.status == 200) {
            Swal.fire({
              title: "Success!",
              text: response.data.data,
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "Ok",
              customClass: {
                confirmButton: "btn btn-success",
              },
            }).then(() => {
               DrawerComponent?.hideAll();
               this.emitter.emit("trainee-updated", true);
            });
          } else {
            let err = "";
            for (const field of Object.keys(response.data.errors)) {
              err += response.data.errors[field][0] + "<br>";
            }
            Swal.fire({
              title: "Please check all the required field",
              html: err,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Close",
              customClass: {
                confirmButton: "btn btn-danger",
              },
            });
          }
        })
        .catch(({ response }) => {
          this.loading = false;
          Swal.fire({
            title: "Unknown error",
            html: response.data.error,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Close",
            customClass: {
              confirmButton: "btn btn-danger",
            },
          });
        });
    },
  },
});
